export default {"src":"/_next/static/media/gray-cart.043ddb55.svg","height":22,"width":24};